import { render } from "./CategoryFilter.vue?vue&type=template&id=5d1c9268&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"

import "./CategoryFilter.vue?vue&type=style&index=0&id=5d1c9268&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1c9268"]])

export default __exports__